/* eslint-disable max-lines-per-function, import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useEffect, useRef } from "react";
import { cn } from "tailwind-variants";
import { useI18n } from "intl/useI18n";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { DTF_PROGRESS_MAPPING } from "common/utils/progress-bar/constants";
import { useDtfStore } from "./store";
import "./DtfProgressBar.scss";

// @ts-expect-error TS(6133): 'UPDATE_INTERVAL' is declared but its value is nev... Remove this comment to see the full error message
const UPDATE_INTERVAL = 50.0;

export default function DtfProgressBar({
  artwork = null,
  index = null,
  onClickRemove,
  ...restProps
}: any) {
  const { t } = useI18n();
  const dtfStore = useDtfStore();

  // State
  // @ts-expect-error TS(6133): 'previousTimeStamp' is declared but its value is n... Remove this comment to see the full error message
  const [previousTimeStamp, setPreviousTimeStamp] = useState(0);
  // @ts-expect-error TS(6133): 'isRunning' is declared but its value is never rea... Remove this comment to see the full error message
  const [isRunning, setIsRunning] = useState(true);
  const [currentProgress, setCurrentProgress] = useState(artwork?.currentProgress || 0);
  const [currentProgressPercentage, setCurrentProgressPercentage] = useState("");
  const [progressText, setProgressTextState] = useState("");

  // Refs
  const timeoutHandleRef = useRef(null);
  const currentProgressRef = useRef(currentProgress);
  const handleOnlineStatusChangeRef = useRef<() => void>(() => {});
  const incrementProgressRef = useRef<() => void>(() => {});
  const cleanupAndSaveStateRef = useRef<() => void>(() => {});

  // Update refs when state changes
  useEffect(() => {
    currentProgressRef.current = currentProgress;
  }, [currentProgress]);

  // Computed properties (as functions)
  // @ts-expect-error TS(6133): 'isRetrying' is declared but its value is never re... Remove this comment to see the full error message
  function isRetrying() {
    // @ts-expect-error TS(4111): Property 'isRetrying' comes from an index signatur... Remove this comment to see the full error message
    return dtfStore.isRetrying;
  }

  function showModal() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.showModal;
  }

  function actionCableConnected() {
    // @ts-expect-error TS(4111): Property 'actionCableConnected' comes from an inde... Remove this comment to see the full error message
    return dtfStore.actionCableConnected;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.isSpangle;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return dtfStore.isStandardArtwork;
  }

  function progressError() {
    return artwork?.uploadError;
  }

  function progress() {
    return artwork?.progress;
  }

  function progressMapIndex() {
    return isSpangle() ? 1 : 0;
  }

  function fileSize() {
    return Math.floor((artwork?.file?.size || 0) * 0.000001 || 0);
  }

  function remainingTime() {
    const spangleTime = isSpangle() ? 1 : 0;
    if (Math.ceil(fileSize() / 10) < 1) {
      return 1 + spangleTime;
    }
    return Math.min(Math.ceil(fileSize() / 10), 15) + spangleTime;
  }

  function progressState() {
    if (progressError()) return "error";
    if (navigator.onLine && actionCableConnected()) return "online";
    return "offline";
  }

  function isOnline() {
    return progressState() === "online" && !artwork?.retryFailed && actionCableConnected();
  }

  function showErrorState() {
    return progressError() || artwork?.retryFailed;
  }

  // @ts-expect-error TS(6133): 'showProcessing' is declared but its value is neve... Remove this comment to see the full error message
  function showProcessing() {
    return isOnline();
  }

  // Methods
  function removeArtworkByIndex(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.removeArtworkByIndex(...args);
  }

  function setIsRetrying(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setIsRetrying(...args);
  }

  function updateArtworkValues(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateArtworkValues(...args);
  }

  // @ts-expect-error TS(6133): 'updateArtworkValuesById' is declared but its valu... Remove this comment to see the full error message
  function updateArtworkValuesById(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.updateArtworkValuesById(...args);
  }

  function setProgressPercentage() {
    const percentage = progressError() ? "100%" : `${currentProgressRef.current.toFixed(2)}%`;
    setCurrentProgressPercentage(percentage);
    setProgressTextState(percentage);
  }

  function deleteArtwork() {
    if (index === null) {
      onClickRemove?.();
    } else {
      removeArtworkByIndex(index);
    }
  }

  function handleOnlineStatusChange() {
    const online = navigator.onLine;
    if (!isOnline()) {
      setIsRunning(false);
      return;
    }
    if (online) {
      setIsRunning(true);
      setIsRetrying(false);
    }
  }

  function cleanupAndSaveState() {
    if (timeoutHandleRef.current) {
      clearTimeout(timeoutHandleRef.current);
    }
    updateArtworkValues({ index, currentProgress: currentProgressRef.current });
  }

  function incrementProgress() {
    const cp = currentProgressRef.current;
    const prog = progress();

    if (cp >= prog) {
      updateArtworkValues({ index: artwork?.originalIndex, currentProgress: cp });
      return;
    }

    const keys = Object.keys(DTF_PROGRESS_MAPPING);
    const currentStageKey = keys.find(
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      key => DTF_PROGRESS_MAPPING[key].percentage[progressMapIndex()] > cp
    );
    // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
    const currentStage = DTF_PROGRESS_MAPPING[currentStageKey];
    let counterInterval = currentStage.interval[progressMapIndex()] || currentStage.interval[0];
    const { rate } = currentStage;
    const nextStageKey = keys.find(
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      key => DTF_PROGRESS_MAPPING[key].percentage[progressMapIndex()] === prog
    );
    // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
    const nextStage = DTF_PROGRESS_MAPPING[nextStageKey];
    const newProgress = parseFloat((cp + rate).toFixed(2));
    setCurrentProgress(newProgress);
    // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    const speedUp = keys.indexOf(nextStageKey) > keys.indexOf(currentStageKey);
    if (speedUp) {
      counterInterval = currentStage.catchUpInterval;
      if (nextStage.skipCatchUp) {
        setCurrentProgress(nextStage.percentage[progressMapIndex()]);
      }
    }
    setProgressPercentage();
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
    timeoutHandleRef.current = setTimeout(() => incrementProgressRef.current(), counterInterval);
  }

  // Keep refs pointing to the latest versions of these functions
  useEffect(() => {
    handleOnlineStatusChangeRef.current = handleOnlineStatusChange;
    incrementProgressRef.current = incrementProgress;
    cleanupAndSaveStateRef.current = cleanupAndSaveState;
  });

  // Lifecycle and event listeners
  useEffect(() => {
    const onOnlineStatusChange = () => handleOnlineStatusChangeRef.current();
    setCurrentProgress(artwork?.currentProgress || 0);
    window.addEventListener("online", onOnlineStatusChange);
    window.addEventListener("offline", onOnlineStatusChange);
    incrementProgressRef.current();

    return () => {
      window.removeEventListener("online", onOnlineStatusChange);
      window.removeEventListener("offline", onOnlineStatusChange);
      cleanupAndSaveStateRef.current();
    };
  }, []);

  // Watch progress
  useEffect(() => {
    if (timeoutHandleRef.current) {
      clearTimeout(timeoutHandleRef.current);
      timeoutHandleRef.current = null;
    }
    incrementProgressRef.current();
  }, [artwork?.progress]);

  // Watch progressState
  useEffect(() => {
    setProgressPercentage();
    // @ts-expect-error TS(4111): Property 'actionCableConnected' comes from an inde... Remove this comment to see the full error message
  }, [artwork?.uploadError, dtfStore.actionCableConnected]);

  // Watch isOnline
  useEffect(() => {
    setProgressPercentage();
    // @ts-expect-error TS(4111): Property 'actionCableConnected' comes from an inde... Remove this comment to see the full error message
  }, [artwork?.retryFailed, dtfStore.actionCableConnected]);

  return (
    <div
      {...restProps}
      className={cn("dtf-progress-bar scope-eec1bfa0", restProps?.className)}
      style={{
        "--eec1bfa0-currentProgressPercentage": currentProgressPercentage
      }}
    >
      {!showErrorState() ? (
        <div
          className={cn("scope-eec1bfa0", {
            "dtf-progress-bar__line-wrap": !isStandardArtwork(),
            "dtf-progress-bar__line-wrap-ab-comparison": isStandardArtwork()
          })}
        >
          {!isStandardArtwork() ? (
            <div
              className="dtf-progress-bar__line scope-eec1bfa0"
              style={{
                width: currentProgressPercentage
              }}
            />
          ) : null}
          {isStandardArtwork() ? (
            <div className="dtf-progress-bar__line-ab-comparison scope-eec1bfa0" />
          ) : null}
        </div>
      ) : null}
      <div
        className={cn("scope-eec1bfa0", {
          "dtf-progress-bar__wrapper": !isStandardArtwork(),
          "dtf-progress-bar__wrapper-ab-comparison": isStandardArtwork()
        })}
      >
        {showErrorState() && showModal() ? (
          <button
            className="dtf-progress-bar__remove-button scope-eec1bfa0"
            type="button"
            onClick={deleteArtwork}
            data-testid="dtf-progress-bar-remove-button"
          >
            <UseSvg
              className="dtf-progress-bar__trash-icon scope-eec1bfa0"
              icon="trash"
              data-testid="dtf-progress-bar-trash-icon"
            />{" "}
            Remove{" "}
          </button>
        ) : null}
        {!showErrorState() ? (
          <div className="dtf-progress-bar__value scope-eec1bfa0">
            {progressText}{" "}
            <span className="dtf-progress-bar__remaining-time scope-eec1bfa0">
              {" "}
              (Less than {t("minute", remainingTime())} left){" "}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
